var map = {
	"./certificate_automatic_frame.png": 248,
	"./certificate_ects_frame.png": 249,
	"./certificate_frame.png": 250,
	"./certificate_verified_frame.png": 251,
	"./frame_blue_de.png": 252,
	"./frame_blue_en.png": 253,
	"./frame_gold_de.png": 254,
	"./frame_gold_en.png": 255,
	"./frame_green_de.png": 256,
	"./frame_green_en.png": 257,
	"./generic_audit_sample.jpg": 258,
	"./generic_bundle_sample.jpg": 259,
	"./generic_coa_ects_sample.jpg": 260,
	"./generic_coa_sample.jpg": 261,
	"./generic_sop_sample.jpg": 262,
	"./milestone_completed.png": 263,
	"./milestone_completed.svg": 264,
	"./milestone_completed_small.svg": 265,
	"./milestone_uncompleted.png": 266,
	"./milestone_uncompleted.svg": 267,
	"./milestone_uncompleted_old.png": 268
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 247;